// extracted by mini-css-extract-plugin
export default {"flex-column":"postDetails_flex-column__QJ1PR","flex-row":"postDetails_flex-row__2ixpR","post-header":"postDetails_post-header__jGuKJ","page-size":"postDetails_page-size__iAc7c"};